import { render } from "./Anunturi.vue?vue&type=template&id=200883b0"
import script from "./Anunturi.vue?vue&type=script&lang=js"
export * from "./Anunturi.vue?vue&type=script&lang=js"

import "./Anunturi.vue?vue&type=style&index=0&id=200883b0&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__